import { NgClass, NgFor, NgIf } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';
import { VexPopoverRef } from '@vex/components/vex-popover/vex-popover-ref';
import { trackById } from '@vex/utils/track-by';
import { AuthService } from 'src/app/core/auth/auth.service';
import { UserAuthData } from 'src/app/core/auth/authData.model';
import { MenuItem } from '../interfaces/menu-item.interface';

export interface OnlineStatus {
  id: 'online' | 'away' | 'dnd' | 'offline';
  label: string;
  icon: string;
  colorClass: string;
}

@Component({
  selector: 'vex-toolbar-user-dropdown',
  templateUrl: './toolbar-user-dropdown.component.html',
  styleUrls: ['./toolbar-user-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatMenuModule,
    NgFor,
    MatRippleModule,
    RouterLink,
    NgClass,
    NgIf
  ]
})
export class ToolbarUserDropdownComponent implements OnInit {
  currentUser: UserAuthData | null = null;
  fullName: string = '';
  imagen: string | ArrayBuffer | null = null;


  items: MenuItem[] = [
    {
      id: '1',
      icon: 'mat:account_circle',
      label: 'Mi Perfil',
      description: 'Información personal',
      colorClass: 'text-teal-600',
      route: '/options-user/profile'
    },
    // {
    //   id: '2',
    //   icon: 'mat:move_to_inbox',
    //   label: 'Mensajes',
    //   description: 'Mensajes y últimas noticias',
    //   colorClass: 'text-primary-600',
    //   route: '/options-user/messages'
    // },
    // {
    //   id: '3',
    //   icon: 'mat:table_chart',
    //   label: 'Contactos',
    //   description: 'Pricing & Current Plan',
    //   colorClass: 'text-purple-600',
    //   route: '/options-user/usercontacts'
    // }
  ];

  statuses: OnlineStatus[] = [
    {
      id: 'online',
      label: 'En línea',
      icon: 'mat:check_circle',
      colorClass: 'text-green-600'
    },
    {
      id: 'away',
      label: 'Away',
      icon: 'mat:access_time',
      colorClass: 'text-orange-600'
    },
    {
      id: 'dnd',
      label: 'No molestar',
      icon: 'mat:do_not_disturb',
      colorClass: 'text-red-600'
    },
    {
      id: 'offline',
      label: 'Desconectado',
      icon: 'mat:offline_bolt',
      colorClass: 'text-gray-600'
    }
  ];

  activeStatus: OnlineStatus = this.statuses[0];

  trackById = trackById;

  constructor(
    private cd: ChangeDetectorRef,
    private popoverRef: VexPopoverRef<ToolbarUserDropdownComponent>,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.currentUser = this.authService.getCurrentUser();

    this.authService.currentUser$.subscribe(user => {
      this.currentUser = user;
      if (user) {
    this.fullName = this.authService.getCurrentUserFullName();
    if (user.imagen) {
      this.imagen = user.imagen;
    }
  }
    })
  }

  setStatus(status: OnlineStatus) {
    this.activeStatus = status;
    this.cd.markForCheck();
  }

  close() {
    this.popoverRef.close();
  }

  logout() {
    this.authService.logout();
    this.popoverRef.close();
  }
}
